import React, { useEffect, useRef, useState } from "react";
import "./style.scss";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import moment from "moment";
import "moment/locale/ru";
import "moment/locale/hy-am";
import Loading from "widgets/loading";
import Clock from "../../../assets/ClockBlog.svg";
import Eye from "../../../assets/EyeBlog.svg";
import Calendar from "../../../assets/CalendarBlog.svg";
import BlogContent from "../../../assets/BlogContent.webp";
import BlogInformation from "../../../assets/BlogInformation.svg";
import GoBack from "../../../assets/GoBackApp.svg";
import PageUp from "../../../assets/PageUp.svg";
import { useStore } from "zustand";
import { marketStore } from "entities/market";
import { getCdnUrl, getMLValue } from "helpers/functions";
import { sircapApi } from "shared/api/sircap";
import { Disclaimer } from "../research-page";
// import { useStore } from "zustand";
// import { dashboardStore } from "entities/dashboard";
// import { marketStore } from "entities/market";
// import { getMLValue } from "helpers/functions";
// import { toast } from "react-toastify";

export const BlogPage = () => {
  const navigate = useNavigate();
  const { alias } = useParams();
  const { i18n } = useTranslation();
  const { t } = useTranslation("app");
  const { loadBlogByAlias, blogByAlias } = useStore(marketStore);

  useEffect(() => {
    loadBlogByAlias(alias!);
  }, [alias]);

  //! figure this out maybe it already done differently // TODO set to true when back available
  // const [isLoading, setIsLoading] = useState(false);
  const [showPageUp, setShowPageUp] = useState(false);
  const [hidden, setHidden] = useState(false);
  const [styleBtn, setStyleBtn] = useState(false);
  const contentRef = useRef<any>(null);

  const pageUp = () => {
    contentRef.current?.scrollTo({ top: 0, behavior: "smooth" });
  };

  const isScrolledToBottom = (el: HTMLElement) =>
    el.scrollTop + el.clientHeight >= el.scrollHeight - 30;

  useEffect(() => {
    if (contentRef.current) {
      let oldScrollY = contentRef.current.scrollTop;
      const onScroll = () => {
        if (isScrolledToBottom(contentRef.current)) {
          setShowPageUp(true);
          setStyleBtn(true);
        } else {
          setStyleBtn(false);
        }

        if (contentRef.current.scrollTop >= 150) {
          setShowPageUp(true);
        } else {
          setShowPageUp(false);
        }

        oldScrollY = contentRef.current.scrollTop;
      };

      contentRef.current.onscroll = onScroll;

      return () => {
        if (contentRef.current) {
          contentRef.current.onscroll = null;
        }
      };
    }
  }, [contentRef.current, showPageUp]);

  useEffect(() => {
    if (!showPageUp) {
      const timeout = setTimeout(() => setHidden(true), 500); // Apply `display: none` after 0.5s
      return () => clearTimeout(timeout);
    } else {
      setHidden(false); // Reset `display` to "flex" immediately when visible
    }
  }, [showPageUp]);

  if (!blogByAlias) {
    return (
      <div className="blogPage" style={{ paddingTop: "10%" }}>
        <div className="blog-page-go-back">
          <img onClick={() => navigate(-1)} src={GoBack} alt="Go Back" />
        </div>
        <div className="not-found-coming-soon">
          <p>{t("notFound")}</p>
        </div>
      </div>
    );
  }

  const localeMap: Record<string, string> = {
    en: "en",
    ru: "ru",
    am: "hy-am",
  };
  const momentDate = moment(blogByAlias.date, "YYYY.MM.DD").locale(
    localeMap[i18n.language] || "en",
  );
  const formattedDate = momentDate.isValid()
    ? momentDate.format("DD.MM.YYYY")
    : "Invalid date";

  // Strapi хранит статью в Markdown, а не в HTML, который отдавала старая
  // админка, — тело рендерит ReactMarkdown ниже.
  const getBlogBody = () =>
    getMLValue(
      {
        en: blogByAlias.content_en,
        ru: blogByAlias.content_ru,
        am: blogByAlias.content_am,
      },
      i18n.language,
    );

  return (
    <div className="blogPage">
      <div className="blog-page-go-back">
        <img onClick={() => navigate(-1)} src={GoBack} alt="Go Back" />
      </div>

      <div className="blog-content-wrapper" ref={contentRef}>
        <div className="blogPageHeader">
          <img
            className="blogPageIconAbsolute"
            src={getCdnUrl(blogByAlias.background_image, "blog")}
            alt="icon"
          />
          <img
            className="blogPageIcon"
            src={getCdnUrl(blogByAlias.background_image, "blog")}
            alt="icon"
          />
          <div className="blogPageHeaderLeft">
            <div className="blogCategoryWrapper">
              {(blogByAlias.categories || []).map((category, index) => (
                <span
                  key={category.id}
                  // todo Add
                  // onClick={(e) => {
                  //   onCategoryClick(category.id);
                  // }}
                >
                  {getMLValue(category.name, i18n.language)}
                  {blogByAlias.categories.length - 1 > index && ","}
                </span>
              ))}
            </div>
            <p>{getMLValue(blogByAlias.title, i18n.language)}</p>
            <div>
              <p>
                <img src={Clock} alt="Clock" />
                {blogByAlias.time_to_read} {t("minBlog")}.
              </p>
              {/* <p>
                <img src={Eye} alt="Eye" />
                {blogByAlias.views}
              </p> */}
              <p>
                <img src={Calendar} alt="Calendar" />
                {formattedDate}
              </p>
            </div>
          </div>
        </div>

        {/* <div className="blogPageSubtitleSection">
          <p className="blogPageSubtitle">
            {getMLValue(blogByAlias.subtitle, i18n.language)}
          </p>
          <div>
            <span>{t("author")}</span>
            <p>{t("teamSiriusCapital")}</p>
          </div>
        </div> */}

        <div className="blogPageContent">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>
            {getBlogBody()}
          </ReactMarkdown>
        </div>

        <a
          className="disclaimer-blog-btn"
          href={getCdnUrl(
            Disclaimer[i18n.language as keyof typeof Disclaimer] ||
              Disclaimer.en,
            "document",
          )}
          download
          target="_blank"
        >
          {t("disclaimer2")}
        </a>
      </div>

      <button
        className="page-up"
        onClick={pageUp}
        style={{
          opacity: showPageUp ? 1 : 0,
          display: hidden ? "none" : "flex",
          bottom: showPageUp ? "-80px" : "0",
          background: showPageUp ? "rgba(255, 255, 255, 0.95)" : "white",
          backdropFilter: showPageUp ? "blur(5px)" : "none",
          boxShadow: showPageUp ? "0px 0px 4px 0px #00000040" : "none",
          animationName: styleBtn ? "pageUp" : "",
          animationDuration: styleBtn ? "1.5s" : "",
        }}
      >
        <img
          src={PageUp}
          alt="PageUp"
          style={{
            animationName: styleBtn ? "pageUpImg" : "",
            animationDuration: styleBtn ? "1.5s" : "",
          }}
        />
      </button>
    </div>
  );
};
